import { Card } from '@blueprintjs/core';
import { AceCard } from '../../../components/AceCard';
import { BucketDetailsPanel } from '../../../components/BucketDetailsPanel';
import { BucketSelectionPanel } from '../../../components/BucketSelectionPanel';
import { useBucketsActions, useSelectedBucket } from '../../../store';
import styles from './BucketsTab.module.css';

interface Props {
  marketCountry: string;
}

export function BucketsTab({ marketCountry }: Props) {
  const bucket = useSelectedBucket();
  const { selectBucket } = useBucketsActions();

  return (
    <div className={styles.container}>
      <AceCard id="BucketSelectionPanel" title="Buckets" isExpandedByDefault>
        <BucketSelectionPanel
          marketCountry={marketCountry}
          selectedBucket={bucket}
          setSelectedBucket={selectBucket}
        />
      </AceCard>

      {bucket && (
        <Card>
          <BucketDetailsPanel id={bucket} />
        </Card>
      )}
    </div>
  );
}
